export default {
    load: false,
    type: 'Custom',
    col: 10,
    columns: [],
    heightFixed: false,
    height: 400,
    defaultFilter: '',
    search: false,
    filters:[],
    opened: {
        searchAdd: false,
        searchEdit: false,
        searchAddPay: false,
        list: [
            {
                label: 'Поиск',
                type: 'label',
                field: '1'
            },
            {
                label: 'Добавление требования на оплату',
                type: 'switch',
                field: 'searchAdd'
            },
            {
                label: 'Редактирование требования на оплату',
                type: 'switch',
                field: 'searchEdit'
            },
            {
                label: 'Добавление платежа',
                type: 'switch',
                field: 'searchAddPay'
            },
        ]
    },
    data: null,


    filter: '',
    visible: false,
    rebind: true,
}